.current-plan-info {
  &__container {
    padding: $space-04 $space-03;
    width: 100%;

    @include agl-ds-screen-size('medium') {
      font-family: $font-family-02;
      padding: $space-06 0;
      width: 100%;
    }
  }

  &__selection {
    display: inline-block;
    gap: $space-01;
    width: 100%;
    font-weight: $font-weight-semi-bold;
    padding: 0;
    text-align: center;

    @include agl-ds-screen-size('medium') {
      text-align: left;
      flex-wrap: wrap;
      display: flex;
    }

    &__message {
      color: $neutral-01;
      font: $font-weight-semi-bold $font-size-lg-06 $font-family-01;

      @include agl-ds-screen-size('medium') {
        flex-grow: 1;
        flex-basis: auto;
        font-size: $font-size-md-07;
      }
    }
  }

  &__header {
    border-radius: $space-01 $space-01 0 0;
    background-color: $neutral-06;
    margin-top: $space-03;
    width: 100%;
    padding: 10px;
    font-family: $font-family-02;
    font-size: 12px;
    text-align: center;

    @include agl-ds-screen-size('medium') {
      padding: 10px;
      width: 131px;
    }
  }

  &-details {
    align-self: stretch;
    font-family: $font-family-02;
    border-radius: 0 0 $space-01 $space-01;
    background-color: $neutral-08;
    display: flex;
    flex-direction: column;
    font-size: $font-size-sm-04;
    justify-content: center;
    padding: 0 $space-01 0 $space-01;
    gap: $space-02;
    width: 100%;

    @include agl-ds-screen-size('medium') {
      border-radius: 0 $space-01 $space-01 $space-01;
      padding: 0 $space-04;
    }

    &__container {
      justify-content: flex-start;
      display: flex;
      flex-direction: column;
      padding: $space-03;
      gap: 0;

      @include agl-ds-screen-size('medium') {
        padding: $space-03 0;
        flex-direction: row;
        gap: $space-08;
      }
    }

    &__icon {
      width: 24px;
      height: 24px;
      margin-right: $space-01;
    }

    &__title {
      display: flex;
      flex-direction: row;
      font-family: $font-family-02;
      font-weight: $font-weight-semi-bold;

      @include agl-ds-screen-size('medium') {
        font-size: $font-size-md-04;
      }
    }

    &__info,
    &__address {
      font: $font-weight-regular $font-size-sm-01 $font-family-02;
      color: $neutral-01;
      margin-top: 8px;

      @include agl-ds-screen-size('medium') {
        font: $font-weight-regular $font-size-md-01 $font-family-02;
      }
    }

    &__item {
      min-width: 30%;
    }

    &__item:not(:first-child) {
      margin-top: $space-03;

      @include agl-ds-screen-size('medium') {
        margin-top: 0;
      }
    }
  }

  &__disclaimer {
    width: 100%;
    font-family: $font-family-02;
    font-size: 12px;
    text-align: center;
    padding: $space-02 $space-03;

    @include agl-ds-screen-size('medium') {
      padding: $space-01 0;
      text-align: left;
    }
  }
}
